




















import type { PropType } from '@nuxtjs/composition-api';
import { defineComponent } from '@nuxtjs/composition-api';

import type { ShoppableImagePinWithPosition } from '~/diptyqueTheme/types/contentful';

export default defineComponent({
  name: 'InstalikePin',
  props: {
    pin: {
      type: Object as PropType<ShoppableImagePinWithPosition | null>,
      default: null
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  emits: ['pin:click']
});
